import type { TransactionModel } from './intents';

export function resolveTransactionModel(
  user: { usesGroupsSince?: unknown } | null | undefined,
  userLoading?: boolean,
): TransactionModel {
  if (userLoading) return 'unresolved';
  if (!user) return 'legacy';
  return user.usesGroupsSince != null ? 'transferGroups' : 'legacy';
}
